import { Component, ElementRef, inject, Input, input } from '@angular/core'
import { ControlValueAccessor, NgControl } from '@angular/forms'

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['../../../../scss/_input.scss'],
  standalone: false,
})
export class TextInputComponent implements ControlValueAccessor {
  public control = inject(NgControl)
  private el = inject(ElementRef)
  @Input()
  disabled!: boolean

  @Input()
  label!: string

  @Input()
  name!: string

  @Input()
  type: 'text' | 'email' | 'password' | 'number' = 'text'

  @Input()
  autocomplete: 'on' | 'off' = 'off'

  @Input()
  required!: boolean

  @Input()
  readonly = false

  @Input()
  icons = true

  // Signal input for type parameter. In a perfect world, signal inputs would be used for all inputs.
  toUppercase = input<boolean | string>(false)

  public value = ''

  public onChange = (_: string): void => {}
  public onTouched = (): void => {}

  constructor() {
    this.control.valueAccessor = this
  }

  transform(value: string): string {
    const uppercase = this.toUppercase()
    // Empty string means attribute with no value, e.g. <input toUppercase> instead of <input toUppercase="true">
    // Since normal html treats attributes with no value as true, we will do the same
    if (uppercase || uppercase === '') {
      return value.toUpperCase()
    }
    return value
  }

  handleValue(event: Event): void {
    const input = event.target as HTMLInputElement
    this.value = this.transform(input.value)
  }

  writeValue(val: string): void {
    this.value = val || ''
    const input = this.el.nativeElement.querySelector('input')
    input.value = this.value
  }

  registerOnChange(fn: () => any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => any): void {
    this.onTouched = fn
  }
}
